/**
 * 解約時アンケート情報を担う
 */
import { useState, useEffect } from 'react';
import { useFetch } from '../common/useFetch';

const initialState = {
  cancelSurveyEnable: false,
  cancelSurveyLeadText: '',
  cancelSurveyRequire: false,
  cancelSurveyExtraField: false,
  reasons: []
}

export const useCancelSurvey = (token: string): UseCancelSurvey => {

  const [cancelSurvey, setCancelSurvey] = useState<CancelSurvey>();
  const [cancelSurveyState, getCancelSurvey] = useFetch<CancelSurvey>('getCancelSurvey', token);

  useEffect(() => getCancelSurvey(), []);

  useEffect(() =>{
    if (!cancelSurveyState?.data) return;
    const cancelSurveyData = cancelSurveyState.data;
    setCancelSurvey(cancelSurveyData);
  }, [cancelSurveyState.data]);

  return {
    cancelSurvey,
    loadingCancelSurvey: cancelSurveyState.loading
  };
};

// types

type UseCancelSurvey = {
  cancelSurvey: CancelSurveyState
  loadingCancelSurvey: boolean
}
export type CancelSurveyState = CancelSurvey | undefined;

export type CancelSurvey = {
  cancelSurveyEnable: boolean;
  cancelSurveyLeadText: string;
  cancelSurveyRequire: boolean;
  cancelSurveyExtraField: boolean;
  reasons: CancelSurveyReason[];
}

export type CancelSurveyReason = {
  text: string;
}
